import { Component, OnInit, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { CurrentPortfolio } from 'src/app/models/current-portfolio.model';
import { CurrentBenchmark } from 'src/app/models/current-benchmark.model';
import { MatTabChangeEvent } from 'node_modules/@angular/material/tabs';
import { ClustersService } from 'src/app/services/clusters.service';
import { Cluster } from 'src/app/models/cluster.model';

import { TableUtil } from "src/app/utils";

@Component({
  selector: 'app-position-keeping',
  templateUrl: './position-keeping.component.html',
  styleUrls: ['./position-keeping.component.scss']
})
export class PositionKeepingComponent implements OnInit, OnDestroy {

  currentCluster: Cluster;
  currentClusterSubscription: Subscription;
  currentOriginal: CurrentPortfolio;
  currentOriginalSubscription: Subscription;
  currentBenchmark: CurrentBenchmark;
  currentBenchmarkSubscription: Subscription;
  currentInvestable: CurrentPortfolio;
  currentInvestableSubscription: Subscription;
  currentProtected: CurrentPortfolio;
  currentProtectedSubscription: Subscription;

  mustUpdateYesNo: boolean = true;
  rebalanceYes: boolean = true;
  rebalanceNo: boolean = false;
  nextRebalancingDate: string = '2020-03-31';

  selectedPerfTab: string ='absolute';
  selectedTurnoverTab: string ='Turnover';
  selectedRebalanceTab: string ='rebalance';
  selectedTab: string = 'Returns';
  selectedTabRelative: string = 'Excess Returns';
  rebalancingTab: string = 'factorExposure';

  selectBlock:string = '';

  panelOpenState = false;

  constructor(private clustersService: ClustersService) {}

  ngOnInit(): void {
    this.subscribeToCurrentCluster();
    this.subscribeToCurrentOriginal();
    this.subscribeToCurrentBenchmark();
    this.subscribeToCurrentInvestable();
    this.subscribeToCurrentProtected();
  }

  ngOnDestroy() {
    if(this.currentClusterSubscription!=undefined) { this.currentClusterSubscription.unsubscribe(); }
    if(this.currentOriginalSubscription!=undefined) { this.currentOriginalSubscription.unsubscribe(); }
    if(this.currentBenchmarkSubscription!=undefined) { this.currentBenchmarkSubscription.unsubscribe(); }
    if(this.currentInvestableSubscription!=undefined) { this.currentInvestableSubscription.unsubscribe(); }
    if(this.currentProtectedSubscription!=undefined) { this.currentProtectedSubscription.unsubscribe(); }
  }

  subscribeToCurrentCluster() {
    this.currentClusterSubscription = this.clustersService.currentClusterSubject.subscribe(
      (cluster: Cluster) => {
        this.currentCluster = cluster;
      }
    );
    this.clustersService.emitCurrentCluster();
  }

  subscribeToCurrentOriginal() {
    this.currentOriginalSubscription = this.clustersService.currentOriginalSubject.subscribe(
      (original_portfolio: CurrentPortfolio) => {
        this.currentOriginal = original_portfolio;
      }
    );
    this.clustersService.emitCurrentOriginal();
  }

  subscribeToCurrentInvestable() {
    this.currentInvestableSubscription = this.clustersService.currentInvestableSubject.subscribe(
      (investable_portfolio: CurrentPortfolio) => {
        this.currentInvestable = investable_portfolio;
      }
    );
    this.clustersService.emitCurrentInvestable();
  }

  subscribeToCurrentProtected() {
    this.currentProtectedSubscription = this.clustersService.currentProtectedSubject.subscribe(
      (protected_portfolio: CurrentPortfolio) => {
        this.currentProtected = protected_portfolio;
      }
    );
    this.clustersService.emitCurrentProtected();
  }

  subscribeToCurrentBenchmark() {
    this.currentBenchmarkSubscription = this.clustersService.currentBenchmarkSubject.subscribe(
      (benchmark: CurrentBenchmark) => {
        this.currentBenchmark = benchmark;
      }
    );
    this.clustersService.emitCurrentBenchmark();
  }

  checkRebalanceYes() {
    if (this.rebalanceYes) {
      this.rebalanceNo = false;
    }else{
      this.rebalanceNo = true;
    }
  }

  checkRebalanceNo() {
    if (this.rebalanceNo) {
      this.rebalanceYes = false;
    }else{
      this.rebalanceYes = true;
    }
  }

  onSelectedTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Returns':               this.selectedTab='Returns'; break;
      case 'Volatility':            this.selectedTab='Volatility'; break;
      case 'Sharpe ratio':          this.selectedTab='Sharpe ratio'; break;
      case 'Max Drawdown':          this.selectedTab='Max Drawdown'; break;
    }
  }

  onSelectedTabChangeRelative(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Excess Returns':        this.selectedTabRelative='Excess Returns'; break;
      case 'Tracking Error':        this.selectedTabRelative='Tracking Error'; break;
      case 'Information ratio':     this.selectedTabRelative='Information ratio'; break;
      case 'Max Relative Drawdown': this.selectedTabRelative='Max Relative Drawdown'; break;
    }
  }

  onRebalancingTabChange(event: MatTabChangeEvent) {
    switch (event.tab.textLabel) {
      case 'Factor Exposure':        this.rebalancingTab='factorExposure'; break;
      case 'Factor Monitoring':      this.rebalancingTab='factorMonitoring'; break;
    }
  }

  formatLabel(value: number) {
    return Math.round(Math.abs(value)) + '%';
  }

  onRebalance() {

  }
  onDoNotRebalance() {

  }

  exportTable(){
    TableUtil.exportToExcel("tableToExport");
  }

}
